export const FORM_FIELD_VALIDATION_ERROR_CLASSNAME = 'validation-error'
